export const fontFamily = {
  primary: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  secondary: "'Oswald', 'Helvetica', 'Arial', sans-serif",
};
